export default [
  {
    path: 'qqtCasesManage',
    name: {list:['全球商通中心','服务案例','案例管理','管理案例'],"portalType":"nfstzxcases"},
    component: () => import('@/views/article/articleManage.vue')
  },
  {
    path: 'qqtCasesAdd',
    name: {list:['全球商通中心','服务案例','案例管理','添加案例'],"portalType":"nfstzxcases"},
    component: () => import('@/views/article/articleAdd.vue')
  },
  {
    path: 'qqtCasesClassifi',
    name: {list:['全球商通中心','服务案例','案例管理','案例分类'],"portalType":"nfstzxcases"},
    component: () => import('@/views/article/articleClassifi.vue')
  },
  {
    path: 'qqtCasesExamM',
    name: {list:['全球商通中心','服务案例','案例审核','案例审核'],"portalType":"nfstzxcases"},
    component: () => import('@/views/article/articleExamM.vue')
  },
  {
    path: 'qqtCasesPz',
    name: {list:['全球商通中心','服务案例','案例审核','案例配置'],"portalType":"nfstzxcases"},
    component: () => import('@/views/article/articlePz.vue')
  },
  
  {
    path: 'qqtCasesExam',
    name: {list:['全球商通中心','服务案例','案例审核','案例审核'],"portalType":"nfstzxcases",title:'案例审核'},
    component: () => import('@/views/article/articleExam.vue')
  },
]